import { useLocation } from 'react-router-dom';
import { extractLangFromPath, SupportedLangCode } from '../config/languages';

/**
 * Returns the current UI language code as read from the URL path.
 * Reacts to route changes automatically.
 */
export const useCurrentLocale = (): SupportedLangCode => {
    const { pathname } = useLocation();
    return extractLangFromPath(pathname);
};
